import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { QueovalItem, eAppContext, QResult } from '../models/global/class.global';
import { TableDefaultValue, BObjectModel } from '../models/bodisplay';
import { HttpService, CoreService } from '../services';
import { BoProperty, DynamicTagsModel, DynamicTagsSaveModel, IBoProperty } from '../models/bodisplay/dynamictags-inline/dynamictags-inline.model';
import { b64UrlEncodeUnicode } from '../utilities';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class BodisplayService {

  private dataBO: Subject<ActionBO> = new Subject<ActionBO>();

  constructor(
    protected http: HttpService,
    protected indParam: CoreService
  ) { }

  //#region lib-components/src/insertdoc/insertdoc.component.ts >> lib-components/src/bodisplay/bodisplay.component.ts

  setDocxName(docxName: string): void {
    const dt: ActionBO = new ActionBO('DOCX', docxName);
    this.dataBO.next(dt);
  }

  //#endregion

  //#region lib-components/src/bodisplay/admin/propdata/admin.propdata.component.ts >> lib-components/src/bodisplay/bodisplay.component.ts

  //////////// when we add a new default-value to a BO's combo-type-property, it updates in the BO component the correspondent property with the new options'list
  //////////reloadPropData(codeProp: string, data: TableDefaultValue[]): void {
  //////////  let cp: string = codeProp;
  //////////  if (codeProp.indexOf('_') > -1) {
  //////////    const ar: string[] = codeProp.split('_');
  //////////    if (ar.length > 0) {
  //////////      cp = ar[ar.length - 1];
  //////////    }
  //////////  }
  //////////  const dt: ActionBO = new ActionBO('UPDPROP', cp.toUpperCase(), JSON.stringify(data));
  //////////  this.dataBO.next(dt);
  //////////}

  //////////// when we add a new default-value to a BO's combo-type-property, it insert the new value within the the correspondent property's options'list
  //////////insertPropData(codeProp: string, data: TableDefaultValue): void {
  //////////  let cp: string = codeProp;
  //////////  if (codeProp.indexOf('_') > -1) {
  //////////    const ar: string[] = codeProp.split('_');
  //////////    if (ar.length > 0) {
  //////////      cp = ar[ar.length - 1];
  //////////    }
  //////////  }
  //////////  const dt: ActionBO = new ActionBO('INSPROP', cp.toUpperCase(), JSON.stringify(data));
  //////////  this.dataBO.next(dt);
  //////////}
  //////////// when we modify the text of a default-value of a group-values, it updates in the BO component all of the combo-type-properties with the options' list derived from the same group
  //////////updateSelectListItem(item: TableDefaultValue): void {
  //////////  const dt: ActionBO = new ActionBO('UPDSELECT', '', JSON.stringify(item));
  //////////  this.dataBO.next(dt);
  //////////}

  //#endregion

  //#region lib-components/src/bodisplay/dynamictag.component.ts >> lib-components/src/bodisplay/admin/propdata/admin.propdata.component.ts

  //////// when we change the combo-property auto-value group, it updates the admin.propdata.component to load the new group values
  //////changeValorAuto(selected: QueovalItem): void {
  //////  const dt: ActionBO = new ActionBO('CHANGEVALAUTO', '', JSON.stringify(selected));
  //////  this.dataBO.next(dt);
  //////}

  //#endregion

  getActionBO(): Observable<ActionBO> {
    return this.dataBO.asObservable();
  }

  //#region Helpers
  public GetIdRelation(strCode_REL: string): Observable<BObjectModel> {
    //return this.http.getHttp<BObjectModel>(`${this.indParam.ConfigFile.apiUrl}api/bobject/getData/GET_ID_RELATION/${strCode_REL}`);
    return this.http.getHttp<BObjectModel>(`${this.indParam.AppParams.apiUrl}api/bobject/getData/GET_ID_RELATION/${strCode_REL}`);
  }
  public GetIdBo(strBoName: string): Observable<BObjectModel> {
    //return this.http.getHttp<BObjectModel>(`${this.indParam.ConfigFile.apiUrl}api/bobject/getData/GET_ID_BO/${strBoName}`);
    return this.http.getHttp<BObjectModel>(`${this.indParam.AppParams.apiUrl}api/bobject/getData/GET_ID_BO/${strBoName}`);
  }
  public GetIdDonnee(strDonneeName: string): Observable<BObjectModel> {
    //return this.http.getHttp<BObjectModel>(`${this.indParam.ConfigFile.apiUrl}api/bobject/getData/GET_ID_DONNEE/${strDonneeName}`);
    return this.http.getHttp<BObjectModel>(`${this.indParam.AppParams.apiUrl}api/bobject/getData/GET_ID_DONNEE/${strDonneeName}`);
  }

  public GetInlinePropertiesDatas(codeBo: string, columns: string[], idDonnee: string): Observable<QResult<Array<IBoProperty<any>>>> {
    idDonnee = !idDonnee ? "0" : idDonnee;
    return this.http.getHttp<QResult<Array<IBoProperty<any>>>>(`${this.indParam.AppParams.apiUrl}api/GET/bo/${codeBo}/idDonnee/${idDonnee}/columns/${b64UrlEncodeUnicode(columns.join('|'))}`);
  }

  public SaveInlinePropertiesDatas(codeBo: string, idDonnee: string, props: Array<IBoProperty<any>>): Observable<QResult<DynamicTagsModel>> {
    const model: DynamicTagsSaveModel = new DynamicTagsSaveModel();
    model.IdBo = codeBo;
    model.IdDonnee = idDonnee;
    model.Properties = props;
    return this.http.postHttp<QResult<DynamicTagsModel>>(`${this.indParam.AppParams.apiUrl}api/dynamictags/SAVE_PROPERTIES`, model).pipe(map((result) => result));
  }
  //#endregion
}



export class ActionBO {
  action: string;
  mode: string;
  stringifyData: string;
  constructor(actionName: string, actionMode: string, data: string = '') {
    this.action = actionName;
    this.mode = actionMode;
    this.stringifyData = data;
  }
}

